import { LifecycleEvent } from 'apprise-core/common'
import { Tenant } from 'apprise-core/tenant'
import { EventSubscription } from "apprise-frontend-events/subscriptions"
import { useCurrentLocation } from 'apprise-ui/link/currentlocation'
import { useHistory } from 'react-router-dom'
import { tenantChangeTopic } from './constants'
import { useTenantStore } from './store'



export type TenantChangeEvent = {
    tenant: Tenant
    type: 'add' | 'remove' | 'change'
}

const isFirstGen = (event:TenantChangeEvent | LifecycleEvent<Tenant>) : event is TenantChangeEvent => !!(event as TenantChangeEvent).tenant
 

export const useTenantChangeListener = (): EventSubscription<TenantChangeEvent | LifecycleEvent<Tenant>> => {

    const tenantstore = useTenantStore()

    const location = useCurrentLocation()

    const history = useHistory()
   
    return {

        topic: tenantChangeTopic

        ,

        onEvent: (e: TenantChangeEvent | LifecycleEvent<Tenant>) => {

            const event: TenantChangeEvent = isFirstGen(e) ? e : { ...e, tenant: e.subject} 

            tenantstore.push(event)

            history.replace(location.current(), `${event.tenant.id}-${event.type}`)
                

        }

    }

}